import { render } from "./View.vue?vue&type=template&id=6d171672"
const script = {}

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__